import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const STORAGE_KEY = "referred_by";

export function getReferredBy() {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(STORAGE_KEY);
}

export default function ReferralTracker() {
  const location = useLocation();
  const [referredBy, setReferredBy] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const searchParams = new URLSearchParams(location.search);
    const referrerFromQuery = searchParams.get("referralApp");
    const existing = localStorage.getItem(STORAGE_KEY);

    if (referrerFromQuery) {
      localStorage.setItem(STORAGE_KEY, referrerFromQuery);
      setReferredBy(referrerFromQuery);
      return;
    }

    if (existing) {
      setReferredBy(existing);
      return;
    }

    const currentPage = `${window.location.origin}${location.pathname}${location.search}`;
    localStorage.setItem(STORAGE_KEY, currentPage);
    setReferredBy(currentPage);
  }, [location]);

  return null;
}
